if (!customElements.get('ae-variant-technical-data')) {
  customElements.define('ae-variant-technical-data', class extends HTMLElement {
    connectedCallback() {
      this.initialize = () => {
        if (this.onVariantChange) return;
        const mains = [...document.querySelectorAll('section[id^="MainProduct-"]')].filter(main =>
          main.dataset.productHandle === this.dataset.productHandle && !main.closest('quick-add-modal,quick-view-modal'));
        if (mains.length !== 1) return;
        this.main = mains[0];
        try { this.variantIds = new Set(JSON.parse(this.dataset.variantIds).map(String)); } catch { return; }
        this.target = this.querySelector('[data-technical-current]');
        this.templates = new Map([...this.querySelectorAll('template[data-technical-variant]')].map(t => [t.dataset.technicalVariant,t]));
        this.fallback = this.querySelector('template[data-technical-fallback]');
        if (!this.target || !this.fallback) return;
        this.current = this.dataset.initialVariant;
        this.expanded = false;
        this.onVariantChange = event => {
          const detail = event.detail || {}, id = String(detail.variant?.id);
          if (String(detail.sectionId) !== this.main.dataset.section || !this.variantIds.has(id)) return;
          this.render(id);
        };
        this.onExpand = event => {
          const button = event.target.closest('[data-expand-technical]');
          if (!button || !this.target.contains(button)) return;
          event.preventDefault(); event.stopImmediatePropagation();
          this.expanded = true; this.expand();
          const table = this.target.querySelector('.technical-table');
          table.tabIndex = -1; table.focus({preventScroll:true});
        };
        document.addEventListener('variant:change',this.onVariantChange);
        this.addEventListener('click',this.onExpand,true);
        // Initial picker event may precede this sibling section. Read the real main form as well as SSR state.
        const input = this.main.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        const id = String(input?.value || this.current);
        if (this.variantIds.has(id)) this.render(id);
        this.syncVisibility();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',this.initialize,{once:true});
      else this.initialize();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded',this.initialize);
      document.removeEventListener('variant:change',this.onVariantChange);
      this.removeEventListener('click',this.onExpand,true);
      this.onVariantChange = null;
    }
    expand() {
      this.target.querySelectorAll('[data-technical-hidden]').forEach(row => { row.hidden=false; row.classList.remove('hidden'); });
      const button = this.target.querySelector('[data-expand-technical]');
      if (button) { button.setAttribute('aria-expanded','true'); button.hidden=true; }
    }
    render(id) {
      if (id === this.current) return;
      const template = this.templates.get(id) || this.fallback;
      this.target.replaceChildren(template.content.cloneNode(true));
      this.current = id;
      if (this.expanded) this.expand();
      this.syncVisibility();
    }
    syncVisibility() {
      const empty = !this.target.querySelector('.technical-table');
      this.dataset.technicalEmpty = String(empty);
      const section = this.closest('[data-pdp-kind="technical"]');
      if (!section) return;
      section.hidden = empty;
      const details = section.closest('.ae-pdp-details');
      const link = [...(details?.querySelectorAll('.ae-pdp-anchors a') || [])].find(a=>a.getAttribute('href')==='#'+section.id);
      if (link) link.hidden=empty;
      const shell = details?.querySelector('[data-pdp-navigation]');
      if (shell) shell.hidden=[...shell.querySelectorAll('.ae-pdp-anchors a')].every(a=>a.hidden);
    }
  });
}
